import { useContext, useEffect } from 'react';
import type { GridRowId } from '@mui/x-data-grid-pro';
import { ExpandableCellContext, isSameCell } from './expandableCellContext';

// Renders nothing, and only exists so an emptied value cannot leave its row at the height it measured.
export const ClosedOnEmptyCell = ({ rowId, field }: { rowId: GridRowId; field: string }) => {
  const { expanded, clearExpanded } = useContext(ExpandableCellContext);
  const isExpanded = isSameCell(expanded, rowId, field);

  useEffect(() => {
    if (isExpanded) clearExpanded?.();
  }, [clearExpanded, isExpanded]);

  return null;
};
